module.exports = __webpack_public_path__ + "a18aa4e6c3e6c384a4b67b87fe3b5fa1.eot";


//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/fonts/ss-junior/webfonts/ss-junior.eot
// module id = 39
// module chunks = 0 1 2 3 4 5 6 7 8 9